import { render, staticRenderFns } from "./AppRodape.vue?vue&type=template&id=fa2555ee&scoped=true"
import script from "./AppRodape.vue?vue&type=script&lang=js"
export * from "./AppRodape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2555ee",
  null
  
)

export default component.exports